import React from "react";

import { Trans, useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Button, Grid, useTheme } from "@mui/material";

import { resetQuerySent } from "../../redux-saga/redux/support/chatsupport";
import useStyle from "./Suppot.style";

const QuerySent = ({ setsupportModal }) => {
  const theme = useTheme();
  const classes = useStyle();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  return (
    <>
      <Grid className={classes.querysuccessWrap}>
        <Grid className={classes.QuerySentIcon}>
          {" "}
          <img src="/images/sportsbook/rightmark.svg" alt="" />{" "}
        </Grid>

        <Grid className={classes.querysentWrap}>
          <p>
            <Trans
              components={{
                b: (
                  <b
                    style={{ color: theme?.palette?.primary2TextColor?.main }}
                  />
                )
              }}
            >
              {t("SUPPORT_MODAL.QUERYSENT_DETAILS")}
            </Trans>
          </p>
          <Grid className={classes.submitBtnWrap}>
            <Button
              onClick={() => {
                setsupportModal(true);
                dispatch(resetQuerySent());
              }}
              className={classes.sendPrimary}
              variant="contained"
              color="secondary"
            >
              <span>{t("SUPPORT_MODAL.GOTO_MY_QUERY")}</span>
            </Button>
          </Grid>
          <Grid className={classes.submitBtnWrap}>
            <Button
              onClick={() => {
                setsupportModal(false);
                dispatch(resetQuerySent());
              }}
              className={classes.sendPrimary}
              variant="contained"
              color="secondary"
            >
              <span>{t("SUPPORT_MODAL.SEND_NEW_QUERY")}</span>
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default QuerySent;
